import { AddOn, Appointment, QuestionnaireSubmission, Service } from '@/types';
import { getAppointmentServiceIds } from './appointmentServices';

// Which questionnaire templates an appointment requires and which are still
// outstanding. Mirrors the customer portal's rules so the technician view and
// the portal agree on what "pending" means:
// - required = every booked service's template + each add-on's template (deduped)
// - a submission without a templateId (legacy rows, paper scans) counts as the
//   FIRST service's template
export const getRequiredQuestionnaireTemplateIds = (
  app: Appointment,
  servicesById: Map<string, Service>,
  addOnsById: Map<string, AddOn>
): string[] => {
  const ids: string[] = [];
  const seen = new Set<string>();
  getAppointmentServiceIds(app).forEach((serviceId) => {
    const serviceTemplateId = servicesById.get(serviceId)?.questionnaireConfig?.templateId;
    if (serviceTemplateId && !seen.has(serviceTemplateId)) {
      seen.add(serviceTemplateId);
      ids.push(serviceTemplateId);
    }
  });
  (app.addOnIds || []).forEach((id) => {
    const templateId = addOnsById.get(id)?.questionnaireConfig?.templateId;
    if (templateId && !seen.has(templateId)) {
      seen.add(templateId);
      ids.push(templateId);
    }
  });
  return ids;
};

export const getPendingQuestionnaireTemplateIds = (
  app: Appointment,
  submissions: readonly QuestionnaireSubmission[],
  servicesById: Map<string, Service>,
  addOnsById: Map<string, AddOn>
): string[] => {
  const requiredIds = getRequiredQuestionnaireTemplateIds(app, servicesById, addOnsById);
  if (requiredIds.length === 0) return [];

  const firstServiceId = getAppointmentServiceIds(app)[0];
  const serviceTemplateId = firstServiceId
    ? servicesById.get(firstServiceId)?.questionnaireConfig?.templateId
    : undefined;
  const submitted = new Set<string>();
  submissions
    .filter((s) => s.appointmentId?.toLowerCase() === app.id?.toLowerCase())
    .forEach((submission) => {
      if (submission.templateId) {
        submitted.add(submission.templateId);
      } else if (serviceTemplateId) {
        submitted.add(serviceTemplateId);
      }
    });

  return requiredIds.filter((id) => !submitted.has(id));
};
